<template>
  <div>
    <LeftSide
      :status="leftSideStatus"
      :key_name="keyName"
      :key_status="keyStatus"
      @filtrate="filtrate"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :keyName="keyName"
        :keyStatus="keyStatus"
        @clearKey="clearKey"
        @editStore="addStore"
      />
      <router-view
        v-if="isSysRights('Warehouse.findWarehouse')"
        :first_loading="firstLoading"
        :items="items"
        @editStore="editStore"
        @changeStatusStore="changeStatusStore"
        @setDefaultStore="setDefaultStore"
        @delStore="delStore"
      ></router-view>
      <no-rights v-else></no-rights>
      <pagination
        v-if="!firstLoading"
        class="pd-x-20 pd-sm-x-30"
        :cur="page"
        :all="totalPage"
        :path="'/warehouse-mgr/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      ></pagination>
      <api-loading :show="loading"></api-loading>
    </div>
    <Modal
      :modalId="'modalEditStore'"
      :home="false"
      :loading="modalEdit.loading"
      :size="'lg'"
      :autoH="true"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{
              modalEdit.type == 1
                ? $t("warehouse.添加仓库")
                : $t("warehouse.修改仓库信息")
            }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.仓库名称：") }}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-6">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model.trim="modalEdit.name"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.所在省市：") }}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-9 row">
              <div class="col-4">
                <select
                  class="form-control form-control-sm"
                  v-model="modalEdit.province"
                >
                  <option
                    v-for="(province, index) in modalEdit.selectProvinceArr"
                    :key="index"
                    :value="index"
                  >
                    {{ province.name }}
                  </option>
                </select>
              </div>
              <div v-if="modalEdit.selectCityArr.length" class="col-4">
                <select
                  class="form-control form-control-sm"
                  v-model="modalEdit.city"
                >
                  <option
                    v-for="(city, index) in modalEdit.selectCityArr"
                    :key="index"
                    :value="index"
                  >
                    {{ city.name }}
                  </option>
                </select>
              </div>
              <div v-if="modalEdit.selectAreaArr.length" class="col-4">
                <select
                  class="from-control form-control-sm"
                  v-model="modalEdit.area"
                >
                  <option
                    v-for="(area, index) in modalEdit.selectAreaArr"
                    :key="index"
                    :value="index"
                  >
                    {{ area.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.具体地址：") }}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-8">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model.trim="modalEdit.address"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.邮编：") }}
            </label>
            <div class="col-4">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model.trim="modalEdit.zipcode"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.联系人：") }}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-4">
              <input
                type="text"
                class="form-control form-control-sm"
                v-model.trim="modalEdit.contact"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.手机：") }}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-5">
              <input
                type="text"
                class="form-control form-control-sm"
                :placeholder="$t('warehouse.手机电话至少填一个')"
                v-model.trim="modalEdit.mobile"
              />
            </div>
          </div>
          <div class="form-group row">
            <label class="col-2 col-form-label form-control-sm text-right">
              {{ $t("warehouse.电话：") }}
              <span class="tx-danger">*</span>
            </label>
            <div class="col-5">
              <input
                type="text"
                class="form-control form-control-sm"
                :placeholder="$t('warehouse.手机电话至少填一个')"
                v-model.trim="modalEdit.telephone"
              />
            </div>
          </div>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="saveStore"
            >
              {{ $t("warehouse.保存") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("warehouse.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :modalId="'modalChangeStatusStore'"
      :home="false"
      :loading="modalChangeStatus.loading"
      :size="'sm'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{
              modalChangeStatus.status == 1
                ? $t("warehouse.停用")
                : $t("warehouse.启用")
            }}{{ $t("warehouse.仓库") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <p :class="{ 'tx-danger': modalChangeStatus.status == 1 }">
            {{ $t("warehouse.要")
            }}{{
              modalChangeStatus.status == 1
                ? $t("warehouse.停用")
                : $t("warehouse.启用")
            }}{{ $t("warehouse.以下仓库么？") }}
          </p>
          <p class="mg-b-0 tx-ellipsis1 tx-black">
            {{ modalChangeStatus.name }}
          </p>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              :class="
                modalChangeStatus.status == 1 ? 'btn-danger' : 'btn-success'
              "
              @click="changeStatus"
            >
              {{
                modalChangeStatus.status == 1
                  ? $t("warehouse.停用")
                  : $t("warehouse.启用")
              }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("warehouse.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :modalId="'modalSetDefaultStore'"
      :home="false"
      :loading="modalSetDefault.loading"
      :size="'sm'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("warehouse.设为默认仓库") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <p>{{ $t("warehouse.要将以下仓库设为默认么？") }}</p>
          <p class="mg-b-0 tx-ellipsis1 tx-black">{{ modalSetDefault.name }}</p>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-primary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="setDefault"
            >
              {{ $t("warehouse.设为默认") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("warehouse.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
    <Modal
      :modalId="'modalDelStore'"
      :home="false"
      :loading="modalDel.loading"
      :size="'sm'"
      :autoH="false"
    >
      <template slot="header">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("warehouse.删除仓库") }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </template>
      <template slot="body">
        <div class="body-inner">
          <p class="tx-danger">{{ $t("warehouse.要删除以下仓库么？") }}</p>
          <p class="mg-b-0 tx-ellipsis1 tx-black">{{ modalDel.name }}</p>
        </div>
      </template>
      <template slot="footer">
        <div class="modal-footer d-block pd-y-15 pd-x-0">
          <div
            class="
              form-group
              row
              align-items-center
              justify-content-end
              pd-x-25
              mg-b-0
            "
          >
            <button
              type="button"
              class="
                mg-r-30
                btn btn-danger
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="del"
            >
              {{ $t("warehouse.删除") }}
            </button>
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("warehouse.取消") }}
            </button>
          </div>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import LeftSide from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //头
import Modal from "@components//Modal";
import { pagination } from "@components/pagination.js"; //分页

export default {
  components: {
    LeftSide,
    Header,
    Modal,
    pagination,
  },
  data() {
    return {
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      loading: true,
      firstLoading: true,
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("warehouse-mgr-rowsPerPage"))
        ? parseInt(store.get("warehouse-mgr-rowsPerPage"))
        : 10,
      totalPage: 0,
      keyName: "",
      keyStatus: "",
      items: [],
      modalEdit: {
        loading: false,
        selectProvinceArr: arrCity,
        selectCityArr: [],
        selectAreaArr: [],
        province: 0,
        city: 0,
        area: 0,
        name: "",
        contact: "",
        zipcode: "",
        mobile: "",
        telephone: "",
        address: "",
        status: 1,
        type: 1,
      },
      modalChangeStatus: {
        loading: false,
        status: 1,
        id: "",
        name: "",
      },
      modalSetDefault: {
        loading: false,
        id: "",
        name: "",
      },
      modalDel: {
        loading: false,
        id: "",
        name: "",
      },
    };
  },
  computed: {
    provinceId() {
      if (this.modalEdit.province) {
        return this.modalEdit.selectProvinceArr[this.modalEdit.province].key;
      } else {
        return "";
      }
    },
    province() {
      if (this.modalEdit.province) {
        return this.modalEdit.selectProvinceArr[this.modalEdit.province].name;
      } else {
        return "";
      }
    },
    city() {
      if (this.modalEdit.city) {
        return this.modalEdit.selectCityArr[this.modalEdit.city].name;
      } else {
        return "";
      }
    },
    area() {
      if (this.modalEdit.selectAreaArr.length) {
        return this.modalEdit.selectAreaArr[this.modalEdit.area].name;
      } else {
        return "";
      }
    },
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("warehouse-mgr-rowsPerPage", this.rowsPerPage);
    },
    "modalEdit.province"() {
      //省选择改变
      if (this.modalEdit.province) {
        //有选择
        this.modalEdit.selectCityArr =
          this.modalEdit.selectProvinceArr[this.modalEdit.province].sub;
      } else {
        this.modalEdit.selectCityArr = [];
      }
      this.modalEdit.selectAreaArr = [];
      this.modalEdit.city = this.modalEdit.area = 0; //清空市区选择
    },
    "modalEdit.city"() {
      //市选择改名
      if (this.modalEdit.city) {
        this.modalEdit.selectAreaArr =
          this.modalEdit.selectCityArr[this.modalEdit.city].sub;
      } else {
        this.modalEdit.selectAreaArr = [];
      }

      this.modalEdit.area = 0;
    },
  },
  methods: {
    del() {
      this.modalDel.loading = true;
      $.api_call(
        "api.Warehouse.deleteWarehouse",
        { id: this.modalDel.id },
        (r) => {
          this.modalDel.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(
              this.$t("warehouse.删除") +
                ` ${this.modalDel.name} ` +
                this.$t("warehouse.成功！"),
              "success"
            );
            $("#modalDelStore").modal("hide");
            this.getItems(true);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    delStore(item) {
      this.modalDel.loading = false;
      this.modalDel.id = item.id;
      this.modalDel.name = item.name;
      $("#modalDelStore").modal("show");
    },
    setDefault() {
      this.modalSetDefault.loading = true;
      $.api_call(
        "api.Warehouse.setDefaultWarehouse",
        { id: this.modalSetDefault.id },
        (r) => {
          this.modalSetDefault.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("warehouse.设置默认成功！"), "success");
            $("#modalSetDefaultStore").modal("hide");
            this.getItems(true);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    setDefaultStore(item) {
      this.modalSetDefault.loading = false;
      this.modalSetDefault.id = item.id;
      this.modalSetDefault.name = item.name;
      $("#modalSetDefaultStore").modal("show");
    },
    changeStatus() {
      this.modalChangeStatus.loading = true;
      $.api_call(
        "api.Warehouse.changeWarehouseStatus",
        { id: this.modalChangeStatus.id },
        (r) => {
          this.modalChangeStatus.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(
              `${
                this.modalChangeStatus.status == 1
                  ? this.$t("warehouse.停用")
                  : this.$t("warehouse.启用")
              }this.$t('warehouse.仓库成功！')`,
              "success"
            );
            $("#modalChangeStatusStore").modal("hide");
            this.getItems(true);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    changeStatusStore(item) {
      this.modalChangeStatus.loading = false;
      this.modalChangeStatus.id = item.id;
      this.modalChangeStatus.status = item.status;
      this.modalChangeStatus.name = item.name;
      $("#modalChangeStatusStore").modal("show");
    },
    clearKey(type) {
      this[type] = "";
      this.toPage(1);
    },
    filtrate(name, status) {
      this.keyName = name;
      this.keyStatus = status;
      this.toPage(1);
    },
    resetEditStore() {
      this.modalEdit = {
        loading: false,
        selectProvinceArr: arrCity,
        selectCityArr: [],
        selectAreaArr: [],
        province: 0,
        city: 0,
        area: 0,
        name: "",
        contact: "",
        zipcode: "",
        mobile: "",
        telephone: "",
        address: "",
        status: 1,
        type: 1,
        id: "",
      };
    },
    addStore() {
      //添加仓库
      this.resetEditStore();
      $("#modalEditStore").modal("show");
    },
    editStore(item) {
      this.$set(this.modalEdit, "province", 0);
      this.$set(this.modalEdit, "city", 0);
      this.modalEdit.name = item.name;
      this.modalEdit.contact = item.contact;
      this.modalEdit.zipcode = item.zipcode;
      this.modalEdit.mobile = item.mobile;
      this.modalEdit.telephone = item.telephone;
      this.modalEdit.address = item.address;
      this.modalEdit.status = item.status;
      this.modalEdit.type = 2;
      this.modalEdit.id = item.id;
      if (item.province) {
        this.modalEdit.selectProvinceArr.forEach((e, i) => {
          if (e.name == item.province) {
            this.$set(this.modalEdit, "province", i);
          }
        });
      }
      let T1 = setInterval(() => {
        if (item.city && this.modalEdit.selectCityArr.length) {
          clearInterval(T1);
          this.modalEdit.selectCityArr.forEach((e, i) => {
            if (e.name == item.city) {
              this.$set(this.modalEdit, "city", i);
            }
          });
        }
      }, 0);
      let T2 = setInterval(() => {
        clearInterval(T2);
        if (item.area && this.modalEdit.selectAreaArr.length) {
          this.modalEdit.selectAreaArr.forEach((e, i) => {
            if (e.name == item.area) {
              this.$set(this.modalEdit, "area", i);
            }
          });
        }
      }, 0);
      $("#modalEditStore").modal("show");
    },
    saveStore() {
      if (!this.modalEdit.name) {
        ShowTip(this.$t("warehouse.仓库名称不能为空！"), "danger");
        return;
      }
      if (!this.province || !this.provinceId) {
        ShowTip(this.$t("warehouse.所在省必须选择！"), "danger");
        return;
      }
      if (!this.city) {
        ShowTip(this.$t("warehouse.所在市必须选择！"), "danger");
        return;
      }
      if (!this.modalEdit.address) {
        ShowTip(this.$t("warehouse.具体地址必须输入！"), "danger");
        return;
      }
      if (!this.modalEdit.contact) {
        ShowTip(this.$t("warehouse.联系人必须输入！"), "danger");
        return;
      }
      if (!this.modalEdit.telephone && !this.modalEdit.mobile) {
        ShowTip(this.$t("warehouse.手机和电话至少输入一个！"), "danger");
        return;
      }
      this.modalEdit.loading = true;
      let params = {
        name: this.modalEdit.name,
        contact: this.modalEdit.contact,
        province: this.province,
        provinceId: this.provinceId,
        city: this.city,
        area: this.area,
        address: this.modalEdit.address,
        zipcode: this.modalEdit.zipcode,
        mobile: this.modalEdit.mobile,
        telephone: this.modalEdit.telephone,
        status: this.modalEdit.status,
      };
      //type 1 新增 2 修改
      let url =
        this.modalEdit.type == 1
          ? "api.Warehouse.addWarehouse"
          : "api.Warehouse.updateWarehouse";
      if (this.modalEdit.type == 2) {
        //如果是修改
        params.id = this.modalEdit.id;
      }
      $.api_call(url, params, (r) => {
        this.modalEdit.loading = false;
        if (r.ErrorCode == "9999") {
          ShowTip(this.$t("warehouse.新仓库添加成功！"), "success");
          $("#modalEditStore").modal("hide");
          this.getItems(true);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    getItems(s) {
      if (!this.isSysRights("Warehouse.findWarehouse")) return;
      this.loading = true;
      let params = {
        status: this.keyStatus,
        name: this.keyName,
        page: this.page,
        rowsPerPage: this.rowsPerPage,
      };
      $.api_call("api.Warehouse.findWarehouse", params, (r) => {
        this.loading = false;
        this.firstLoading = false;
        if (r.ErrorCode == "9999") {
          this.items = r.Data.Results;
          this.totalPage = r.Data.Pagination.totalPage;
          this.totalCount = r.Data.Pagination.totalCount;
          if (this.page > r.Data.Pagination.totalPage)
            this.page = r.Data.Pagination.totalPage
              ? r.Data.Pagination.totalPage
              : 1;
          if (!s) $("html,body").scrollTop(0);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(this);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getItems();
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({
        path: "/warehouse-mgr/" + 1,
        query: this.$route.query,
      });
      if (page == 1) {
        this.getItems();
      }
    },
    toPage(num) {
      let page = this.page;
      this.$router.push({
        path: "/warehouse-mgr/" + num,
        query: this.$route.query,
      });
      if (page == num) {
        this.getItems();
      }
    },
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.getItems();
  },
  updated() {
    $(".overflow-y-auto").perfectScrollbar();
    $('[data-toggle="tooltip-primary"]').tooltip({
      template:
        '<div class="tooltip tooltip-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
    });
  },
};
</script>